import { AfterViewInit, Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';
import { HelpNavigationService } from '../services/help-navigation.service';

@Component({
  selector: 'app-help-side-bar',
  imports: [RouterModule],
  templateUrl: './help-side-bar.component.html',
  styleUrl: './help-side-bar.component.scss'
})

export class HelpSideBarComponent implements OnInit {

  selectedSection = '';

  sectionMap: any = {};

  constructor(
    private navigationService: HelpNavigationService
  ) { }

  ngOnInit(): void {

    this.navigationService.selectedSection.subscribe(section => {

      console.log('Sidebar received:', section);

      this.selectedSection =
        this.sectionMap[section] || section;

    });

  }

  changeSection(section: string): void {

    this.selectedSection =
      this.sectionMap[section] || section;

    this.navigationService.selectedSection.next(section);

  }

  parentMenus = [
    'copyright',
    'licence',
    'introToggle',
    'quickReferenceToggle',
    'charitiesToggle',
    'accountingPeriodToggle',
    'submissionHistoryToggle',
    'ReportsToggle',
    'settingsToggle'
  ];

  childMenus = [
    'CreateCharityToggle',
    'trialBalanceToggleMenu',
    'notesToggle',
    'trusteesReportToggle',
    'trusteeResponsibilityToggle',
    'examinerReportToggle',
    'AuditorsReportToggle',
    'finalAccountsToggle',
    'submissionToggle',
    'preferenceToggle',
    'userManagementToggle'
  ];

  closeAllMenus(): void {

    document.querySelectorAll('.submenu-toggle').forEach(item => {
      (item as HTMLInputElement).checked = false;
    });

    this.selectedSection = '';

    this.navigationService.selectedSection.next('');
  }

  toggleSubmenu(event: Event, id: string): void {

    const target = event.target as HTMLElement;

    if (target.closest('.chevron')) {
      return;
    }

    const checkbox =
      document.getElementById(id) as HTMLInputElement;

    if (!checkbox) {
      return;
    }

    if (this.parentMenus.includes(id)) {

      this.parentMenus.forEach(menuId => {
        if (menuId !== id) {
          const menu =
            document.getElementById(menuId) as HTMLInputElement;

          if (menu) {
            menu.checked = false;
          }
        }
      });
    }

    checkbox.checked = !checkbox.checked;
  }

  
}
